import classNames from 'classnames';
import { OrdersBasketToolbarProps } from 'components/Workspaces/OrdersBasket/Toolbar/OrdersBasketToolbar.models';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export type OrdersBasketInteractionToolbarProps = OrdersBasketToolbarProps & {
  classNames?: string;
};

const StyledDiv = styled.div`
  position: absolute;
  bottom: 0px;
  left: 0px;
`;

export const OrdersBasketInteractionToolbarComponent: FC<OrdersBasketInteractionToolbarProps> = ({
  numberOfFormsSelected,
  canDeleteSelectedItems,
  canBookSelectedItems,
  canCancelSelectedItems,
  onBook,
  onDelete,
  onCancel,
  onClearSelection,
}) => {
  const onBookTriggered = useCallback(() => {
    onBook();
  }, [onBook]);

  const onDeleteTriggered = useCallback(() => {
    onDelete();
  }, [onDelete]);

  const onClearSelectionTriggered = useCallback(() => {
    onClearSelection();
  }, [onClearSelection]);

  const onCancelTriggered = useCallback(() => {
    onCancel();
  }, [onCancel]);

  if (numberOfFormsSelected === 0) {
    return null;
  }

  return (
    <StyledDiv
      className={classNames(
        classNames,
        'd-flex align-items-center justify-content-between p-2 is-sticky-bottom bg-info h-auto w-100',
      )}
      data-e2e="orders-basket-interaction-toolbar-div"
    >
      <div>
        <span
          className="badge badge-lg rounded-pill badge-primary-alt mx-2 px-2"
          data-e2e="orders-basket-nb-orders-selected"
        >
          {numberOfFormsSelected}
        </span>
        <FormattedMessage id="ordersBasket.ordersSelected" />
      </div>
      <div className="d-flex">
        <div className="d-flex pe-2">
          <button
            className="btn btn-lg btn-flat-primary-alt"
            onClick={onClearSelectionTriggered}
            type="button"
            data-e2e="orders-basket-deselect-all-button"
          >
            <FormattedMessage id="clearSelection" />
          </button>
          <button
            className="btn btn-lg btn-flat-primary-alt"
            disabled={!canDeleteSelectedItems}
            onClick={onDeleteTriggered}
            type="button"
            data-e2e="orders-basket-delete-button"
          >
            <FormattedMessage id="delete" />
            <i className="icon icon-ms ms-2">delete_outline</i>
          </button>
        </div>
        <div className="d-flex ps-2 border-start">
          <button
            className="btn btn-lg btn-discreet-primary-alt ms-2"
            disabled={!canCancelSelectedItems}
            type="button"
            onClick={onCancelTriggered}
            data-e2e="orders-basket-cancel-button"
          >
            <FormattedMessage id="cancel" />
          </button>

          <button
            className="btn btn-lg btn-outline-primary-alt ms-2"
            disabled={!canBookSelectedItems}
            onClick={onBookTriggered}
            type="button"
            data-e2e="orders-basket-book-button"
          >
            <FormattedMessage id="book" />
          </button>
        </div>
      </div>
    </StyledDiv>
  );
};
